import {Component, effect, inject, signal} from '@angular/core';
import {MaterialModule} from '../../../../core/modules/material.module';
import {SharedModule} from '../../../../core/modules/shared.module';
import {PagesContainerComponent} from '../../pages-container/pages-container.component';
import {ForumTalkService} from '../../../../core/services/forumTalk.service';
import {MatDialog} from '@angular/material/dialog';
import {EditContentModal} from '../edit-forum-content/edit-content.modal';
import moment from 'moment/moment';
import {FuseDeleteDialogComponent} from '../../../../core/components/delete-dialog/delete-dialog.component';

@Component({
  selector: 'app-forum-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
  standalone: true,
  imports: [MaterialModule, SharedModule, PagesContainerComponent],
  providers: [ForumTalkService]
})

export class ForumNewsComponent {
  private forumTalkService = inject(ForumTalkService);
  private dialog = inject(MatDialog);

  news = signal<[]>([]);
  sort = signal('id');
  direction = signal('desc');
  pageIndex = signal(0);
  perPage = signal(50);
  pagination = signal<any>(null);
  displayedColumns = ['text', 'date', 'edit', 'delete'];

  constructor() {
    effect(() => {
      const s = this.sort();
      const d = this.direction();
      const p = this.pageIndex();
      const pp = this.perPage();
      this.getNews();
    });
  }

  getNews() {
    this.forumTalkService.getNews().subscribe((res: any) => {
      this.news.set(res.news);
      this.pagination.set(res.pagination);
    });
  }

  sortData(e) {
    if (!e.direction) {
      this.sort.set('id');
      this.direction.set('desc');
    } else {
      this.sort.set(e.active);
      this.direction.set(e.direction);
    }
    this.restoreScroll();
  }

  private restoreScroll() {
    const table = document.getElementById('newsPage');
    if (table) {
      table.scrollTop = 0;
    }
  }

  handlePageEvent(e) {
    this.pageIndex.set(e.pageIndex);
    this.perPage.set(e.pageSize);
  }

  addNews() {
    const dialogRef = this.dialog.open(EditContentModal, {
      width: '600px',
      data: {header: 'forumTalk.add_news', type: 'news'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          text: result.text,
          date: moment(result.date).toISOString()
        };
        this.forumTalkService.addNews(data).subscribe((res: any) => {
          this.getNews();
        });
      }
    });
  }

  editNews(news) {
    const dialogRef = this.dialog.open(EditContentModal, {
      width: '600px',
      data: {header: 'forumTalk.edit_news', type: 'news', data: news}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          text: result.text,
          date: moment(result.date).toISOString()
        };
        this.forumTalkService.updateNews(news.id, data).subscribe((res: any) => {
          this.getNews();
        });
      }
    });
  }

  deleteNews(news) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent, {
      panelClass: 'unsave-form-dialog',
      width: '300px',
      data: {title: 'Delete', message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.forumTalkService.deleteNews(news.id).subscribe((res: any) => {
          this.getNews();
        });
      }
    });
  }
}
